module.exports = __webpack_public_path__ + "img/img_aboutus_2.da81d39a.jpg";